<!-- @veltra/icons generated sha256:3053d193f40f01dc gen:8 source:src/svg/colorful/power-point.svg -->
<script setup lang="ts">
defineOptions({ name: 'PowerPoint' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <defs>
      <clipPath id="a"><rect width="16" height="16" rx="0" /></clipPath>
    </defs>
    <g clip-path="url(#a)">
      <path
        fill="#f98950"
        d="M10.29 1H4.207C2.987 1 2 1.987 2 3.206v9.578c0 1.22.989 2.208 2.208 2.208h7.586c1.22 0 2.208-.989 2.208-2.208V4.71c0-.497-.197-.974-.549-1.326l-1.836-1.836A1.88 1.88 0 0 0 10.29 1"
      />
      <path
        fill="#f26c38"
        d="m13.452 3.384-1.836-1.836a1.9 1.9 0 0 0-.965-.514v2.06c0 .655.53 1.185 1.185 1.185h2.115a1.87 1.87 0 0 0-.5-.895m-4.764 2.06H5.943a.375.375 0 0 0-.375.374v4.73a.375.375 0 0 0 .75 0V9.307h2.37a1.934 1.934 0 0 0 1.931-1.931 1.934 1.934 0 0 0-1.931-1.932m0 3.112h-2.37V6.193h2.37a1.183 1.183 0 0 1 0 2.363"
      />
      <path
        fill="#fff"
        d="M8.688 5.256H5.943a.375.375 0 0 0-.375.375v4.73a.375.375 0 0 0 .75 0V9.12h2.37a1.934 1.934 0 0 0 1.931-1.932 1.934 1.934 0 0 0-1.931-1.931m0 3.113h-2.37V6.006h2.37a1.183 1.183 0 0 1 0 2.363"
      />
    </g>
  </svg>
</template>
